import { NoticePage } from './NoticePage'
import { FAIR_HOUSING_TITLE, FAIR_HOUSING_CONTENT } from './disclosureContent'

export function FairHousingActNotice() {
  return (
    <NoticePage
      title={FAIR_HOUSING_TITLE}
      content={FAIR_HOUSING_CONTENT}
      linkType="terms_fair"
    />
  )
}
